import { useMemo, useState } from "react";
import * as guestGroupService from "../../services/guestGroupService";

type NuevoInvitado = {
  nombre: string;
  apellido: string;
  codigoPais: string;
  telefono: string;
  email: string;
  esPrincipal: boolean;
};

export type CountryCodeOption = {
  country: string;
  code: string;
};

export const COUNTRY_CODES: CountryCodeOption[] = [
  { country: "Afganistan", code: "+93" },
  { country: "Albania", code: "+355" },
  { country: "Alemania", code: "+49" },
  { country: "Andorra", code: "+376" },
  { country: "Angola", code: "+244" },
  { country: "Anguila", code: "+1264" },
  { country: "Antigua y Barbuda", code: "+1268" },
  { country: "Arabia Saudita", code: "+966" },
  { country: "Argelia", code: "+213" },
  { country: "Argentina", code: "+54" },
  { country: "Armenia", code: "+374" },
  { country: "Aruba", code: "+297" },
  { country: "Australia", code: "+61" },
  { country: "Austria", code: "+43" },
  { country: "Azerbaiyan", code: "+994" },
  { country: "Bahamas", code: "+1242" },
  { country: "Banglades", code: "+880" },
  { country: "Barbados", code: "+1246" },
  { country: "Barein", code: "+973" },
  { country: "Belgica", code: "+32" },
  { country: "Belice", code: "+501" },
  { country: "Benin", code: "+229" },
  { country: "Bermudas", code: "+1441" },
  { country: "Bielorrusia", code: "+375" },
  { country: "Bolivia", code: "+591" },
  { country: "Bonaire, San Eustaquio y Saba", code: "+599" },
  { country: "Bosnia y Herzegovina", code: "+387" },
  { country: "Botsuana", code: "+267" },
  { country: "Brasil", code: "+55" },
  { country: "Brunei", code: "+673" },
  { country: "Bulgaria", code: "+359" },
  { country: "Burkina Faso", code: "+226" },
  { country: "Burundi", code: "+257" },
  { country: "Butan", code: "+975" },
  { country: "Cabo Verde", code: "+238" },
  { country: "Camboya", code: "+855" },
  { country: "Camerun", code: "+237" },
  { country: "Canada", code: "+1" },
  { country: "Catar", code: "+974" },
  { country: "Chad", code: "+235" },
  { country: "Chile", code: "+56" },
  { country: "China", code: "+86" },
  { country: "Chipre", code: "+357" },
  { country: "Colombia", code: "+57" },
  { country: "Comoras", code: "+269" },
  { country: "Congo", code: "+242" },
  { country: "Corea del Norte", code: "+850" },
  { country: "Corea del Sur", code: "+82" },
  { country: "Costa de Marfil", code: "+225" },
  { country: "Costa Rica", code: "+506" },
  { country: "Croacia", code: "+385" },
  { country: "Cuba", code: "+53" },
  { country: "Curazao", code: "+599" },
  { country: "Dinamarca", code: "+45" },
  { country: "Dominica", code: "+1767" },
  { country: "Ecuador", code: "+593" },
  { country: "Egipto", code: "+20" },
  { country: "El Salvador", code: "+503" },
  { country: "Emiratos Arabes Unidos", code: "+971" },
  { country: "Eritrea", code: "+291" },
  { country: "Eslovaquia", code: "+421" },
  { country: "Eslovenia", code: "+386" },
  { country: "Espana", code: "+34" },
  { country: "Estados Unidos", code: "+1" },
  { country: "Estonia", code: "+372" },
  { country: "Etiopia", code: "+251" },
  { country: "Filipinas", code: "+63" },
  { country: "Finlandia", code: "+358" },
  { country: "Fiyi", code: "+679" },
  { country: "Francia", code: "+33" },
  { country: "Gabon", code: "+241" },
  { country: "Gambia", code: "+220" },
  { country: "Georgia", code: "+995" },
  { country: "Ghana", code: "+233" },
  { country: "Gibraltar", code: "+350" },
  { country: "Granada", code: "+1473" },
  { country: "Grecia", code: "+30" },
  { country: "Groenlandia", code: "+299" },
  { country: "Guadalupe", code: "+590" },
  { country: "Guam", code: "+1671" },
  { country: "Guatemala", code: "+502" },
  { country: "Guayana Francesa", code: "+594" },
  { country: "Guernsey", code: "+44" },
  { country: "Guinea", code: "+224" },
  { country: "Guinea Ecuatorial", code: "+240" },
  { country: "Guinea-Bisau", code: "+245" },
  { country: "Guyana", code: "+592" },
  { country: "Haiti", code: "+509" },
  { country: "Honduras", code: "+504" },
  { country: "Hong Kong", code: "+852" },
  { country: "Hungria", code: "+36" },
  { country: "India", code: "+91" },
  { country: "Indonesia", code: "+62" },
  { country: "Irak", code: "+964" },
  { country: "Iran", code: "+98" },
  { country: "Irlanda", code: "+353" },
  { country: "Isla de Man", code: "+44" },
  { country: "Isla de Navidad", code: "+61" },
  { country: "Islandia", code: "+354" },
  { country: "Islas Caiman", code: "+1345" },
  { country: "Islas Cook", code: "+682" },
  { country: "Islas Feroe", code: "+298" },
  { country: "Islas Malvinas", code: "+500" },
  { country: "Islas Marshall", code: "+692" },
  { country: "Islas Salomon", code: "+677" },
  { country: "Islas Turcas y Caicos", code: "+1649" },
  { country: "Islas Virgenes Britanicas", code: "+1284" },
  { country: "Islas Virgenes de EE. UU.", code: "+1340" },
  { country: "Israel", code: "+972" },
  { country: "Italia", code: "+39" },
  { country: "Jamaica", code: "+1876" },
  { country: "Japon", code: "+81" },
  { country: "Jersey", code: "+44" },
  { country: "Jordania", code: "+962" },
  { country: "Kazajistan", code: "+7" },
  { country: "Kenia", code: "+254" },
  { country: "Kirguistan", code: "+996" },
  { country: "Kiribati", code: "+686" },
  { country: "Kosovo", code: "+383" },
  { country: "Kuwait", code: "+965" },
  { country: "Laos", code: "+856" },
  { country: "Lesoto", code: "+266" },
  { country: "Letonia", code: "+371" },
  { country: "Libano", code: "+961" },
  { country: "Liberia", code: "+231" },
  { country: "Libia", code: "+218" },
  { country: "Liechtenstein", code: "+423" },
  { country: "Lituania", code: "+370" },
  { country: "Luxemburgo", code: "+352" },
  { country: "Macao", code: "+853" },
  { country: "Macedonia del Norte", code: "+389" },
  { country: "Madagascar", code: "+261" },
  { country: "Malasia", code: "+60" },
  { country: "Malaui", code: "+265" },
  { country: "Maldivas", code: "+960" },
  { country: "Mali", code: "+223" },
  { country: "Malta", code: "+356" },
  { country: "Marruecos", code: "+212" },
  { country: "Martinica", code: "+596" },
  { country: "Mauricio", code: "+230" },
  { country: "Mauritania", code: "+222" },
  { country: "Mayotte", code: "+262" },
  { country: "Mexico", code: "+52" },
  { country: "Micronesia", code: "+691" },
  { country: "Moldavia", code: "+373" },
  { country: "Monaco", code: "+377" },
  { country: "Mongolia", code: "+976" },
  { country: "Montenegro", code: "+382" },
  { country: "Montserrat", code: "+1664" },
  { country: "Mozambique", code: "+258" },
  { country: "Myanmar", code: "+95" },
  { country: "Namibia", code: "+264" },
  { country: "Nauru", code: "+674" },
  { country: "Nepal", code: "+977" },
  { country: "Nicaragua", code: "+505" },
  { country: "Niger", code: "+227" },
  { country: "Nigeria", code: "+234" },
  { country: "Niue", code: "+683" },
  { country: "Noruega", code: "+47" },
  { country: "Nueva Caledonia", code: "+687" },
  { country: "Nueva Zelanda", code: "+64" },
  { country: "Oman", code: "+968" },
  { country: "Paises Bajos", code: "+31" },
  { country: "Pakistan", code: "+92" },
  { country: "Palaos", code: "+680" },
  { country: "Palestina", code: "+970" },
  { country: "Panama", code: "+507" },
  { country: "Papua Nueva Guinea", code: "+675" },
  { country: "Paraguay", code: "+595" },
  { country: "Peru", code: "+51" },
  { country: "Polinesia Francesa", code: "+689" },
  { country: "Polonia", code: "+48" },
  { country: "Portugal", code: "+351" },
  { country: "Puerto Rico", code: "+1787" },
  { country: "Puerto Rico", code: "+1939" },
  { country: "Reino Unido", code: "+44" },
  { country: "Republica Centroafricana", code: "+236" },
  { country: "Republica Checa", code: "+420" },
  { country: "Republica Democratica del Congo", code: "+243" },
  { country: "Republica Dominicana", code: "+1809" },
  { country: "Republica Dominicana", code: "+1829" },
  { country: "Republica Dominicana", code: "+1849" },
  { country: "Reunion", code: "+262" },
  { country: "Ruanda", code: "+250" },
  { country: "Rumania", code: "+40" },
  { country: "Rusia", code: "+7" },
  { country: "Sahara Occidental", code: "+212" },
  { country: "Samoa", code: "+685" },
  { country: "Samoa Americana", code: "+1684" },
  { country: "San Bartolome", code: "+590" },
  { country: "San Cristobal y Nieves", code: "+1869" },
  { country: "San Marino", code: "+378" },
  { country: "San Martin", code: "+590" },
  { country: "San Pedro y Miquelon", code: "+508" },
  { country: "San Vicente y las Granadinas", code: "+1784" },
  { country: "Santa Elena", code: "+290" },
  { country: "Santa Lucia", code: "+1758" },
  { country: "Santo Tome y Principe", code: "+239" },
  { country: "Senegal", code: "+221" },
  { country: "Serbia", code: "+381" },
  { country: "Seychelles", code: "+248" },
  { country: "Sierra Leona", code: "+232" },
  { country: "Singapur", code: "+65" },
  { country: "Sint Maarten", code: "+1721" },
  { country: "Siria", code: "+963" },
  { country: "Somalia", code: "+252" },
  { country: "Sri Lanka", code: "+94" },
  { country: "Suazilandia", code: "+268" },
  { country: "Sudafrica", code: "+27" },
  { country: "Sudan", code: "+249" },
  { country: "Sudan del Sur", code: "+211" },
  { country: "Suecia", code: "+46" },
  { country: "Suiza", code: "+41" },
  { country: "Surinam", code: "+597" },
  { country: "Tailandia", code: "+66" },
  { country: "Taiwan", code: "+886" },
  { country: "Tanzania", code: "+255" },
  { country: "Tayikistan", code: "+992" },
  { country: "Timor Oriental", code: "+670" },
  { country: "Togo", code: "+228" },
  { country: "Tokelau", code: "+690" },
  { country: "Tonga", code: "+676" },
  { country: "Trinidad y Tobago", code: "+1868" },
  { country: "Tunez", code: "+216" },
  { country: "Turkmenistan", code: "+993" },
  { country: "Turquia", code: "+90" },
  { country: "Tuvalu", code: "+688" },
  { country: "Ucrania", code: "+380" },
  { country: "Uganda", code: "+256" },
  { country: "Uruguay", code: "+598" },
  { country: "Uzbekistan", code: "+998" },
  { country: "Vanuatu", code: "+678" },
  { country: "Vaticano", code: "+379" },
  { country: "Venezuela", code: "+58" },
  { country: "Vietnam", code: "+84" },
  { country: "Wallis y Futuna", code: "+681" },
  { country: "Yemen", code: "+967" },
  { country: "Yibuti", code: "+253" },
  { country: "Zambia", code: "+260" },
  { country: "Zimbabue", code: "+263" },
];

export const DEFAULT_COUNTRY_CODE = "+51";

export function normalizeSearch(value: string) {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}

export function formatPhone(codigoPais: string, telefono: string) {
  const number = telefono.trim();
  if (!number) return "";
  return `${codigoPais}${number}`;
}

export function findCountryCodeByCountryName(countryName: string) {
  const normalized = normalizeSearch(countryName.trim());
  if (!normalized) return null;

  return (
    COUNTRY_CODES.find((option) => normalizeSearch(option.country) === normalized)?.code ??
    COUNTRY_CODES.find((option) => normalizeSearch(option.country).includes(normalized))?.code ??
    null
  );
}

type Props = {
  open: boolean;
  onClose: () => void;
  onCreated: (grupo: guestGroupService.GrupoInvitados) => void;
  eventoId: number;
};

export default function CreateGuestGroupModal({ open, onClose, onCreated, eventoId }: Props) {
  const [nombreGrupo, setNombreGrupo] = useState("");
  const [tipo, setTipo] = useState<guestGroupService.TipoGrupoInvitados>("FAMILIA");
  const [adicionales, setAdicionales] = useState<number>(0);

  const [nuevo, setNuevo] = useState<NuevoInvitado>({
    nombre: "",
    apellido: "",
    codigoPais: DEFAULT_COUNTRY_CODE,
    telefono: "",
    email: "",
    esPrincipal: true,
  });

  const [invitados, setInvitados] = useState<NuevoInvitado[]>([]);
  const [codigoPaisQuery, setCodigoPaisQuery] = useState("Peru +51");
  const [isCountryCodeOpen, setIsCountryCodeOpen] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isSaving, setIsSaving] = useState(false);

  const cupoTotal = useMemo(() => 1 + Number(adicionales || 0), [adicionales]);
  const filteredCountryCodes = useMemo(() => {
    const query = normalizeSearch(codigoPaisQuery.trim());
    if (!query) return COUNTRY_CODES;

    return COUNTRY_CODES.filter((option) => {
      const label = normalizeSearch(`${option.country} ${option.code}`);
      return label.includes(query);
    });
  }, [codigoPaisQuery]);

  const selectedCountryCode = useMemo(() => {
    return COUNTRY_CODES.find((option) => option.code === nuevo.codigoPais) ?? COUNTRY_CODES[0];
  }, [nuevo.codigoPais]);

  function reset() {
    setNombreGrupo("");
    setTipo("FAMILIA");
    setAdicionales(0);
    setNuevo({
      nombre: "",
      apellido: "",
      codigoPais: DEFAULT_COUNTRY_CODE,
      telefono: "",
      email: "",
      esPrincipal: true,
    });
    setInvitados([]);
    setCodigoPaisQuery("Peru +51");
    setIsCountryCodeOpen(false);
    setError(null);
    setIsSaving(false);
  }

  function cerrar() {
    if (isSaving) return;
    reset();
    onClose();
  }

  function agregarInvitado() {
    setError(null);

    const n = nuevo.nombre.trim();
    const a = nuevo.apellido.trim();
    if (!n || !a) {
      setError("Completa el nombre y apellido del invitado.");
      return;
    }

    let next = [...invitados, { ...nuevo, nombre: n, apellido: a, telefono: nuevo.telefono.trim() }];

    // Si el nuevo se marca principal, deja SOLO 1 principal (el último agregado)
    if (nuevo.esPrincipal) {
      next = next.map((x, idx) => ({ ...x, esPrincipal: idx === next.length - 1 }));
    }

    // Si no hay principal todavía, fuerza principal al primero
    if (!next.some((x) => x.esPrincipal)) {
      next[0] = { ...next[0], esPrincipal: true };
    }

    setInvitados(next);
    setNuevo({
      nombre: "",
      apellido: "",
      codigoPais: DEFAULT_COUNTRY_CODE,
      telefono: "",
      email: "",
      esPrincipal: false,
    });
    setCodigoPaisQuery("Peru +51");
    setIsCountryCodeOpen(false);
  }

  function eliminarInvitado(idx: number) {
    const next = invitados.filter((_, i) => i !== idx);
    if (next.length > 0 && !next.some((x) => x.esPrincipal)) {
      next[0] = { ...next[0], esPrincipal: true };
    }
    setInvitados(next);
  }

  function marcarPrincipal(idx: number) {
    const next = invitados.map((x, i) => ({ ...x, esPrincipal: i === idx }));
    setInvitados(next);
  }

  async function guardar() {
    setError(null);

    const ng = nombreGrupo.trim();
    if (!ng) return setError("El nombre del grupo es obligatorio.");

    if (!eventoId || Number.isNaN(eventoId)) return setError("Evento inválido.");

    if (invitados.length === 0) return setError("Agrega al menos un invitado (principal).");

    const principals = invitados.filter((x) => x.esPrincipal);
    if (principals.length !== 1) {
      return setError("Debe existir exactamente 1 invitado principal.");
    }

    // Validación de cupo (opcional pero recomendable)
    // Cupo total = maxInvitados. asistentes.length no debe excederlo.
    const maxInvitados = cupoTotal;
    if (invitados.length > maxInvitados) {
      return setError(`Has agregado ${invitados.length} invitados, pero el cupo total es ${maxInvitados}.`);
    }

    setIsSaving(true);
    try {
      const payload: guestGroupService.CreateGrupoInvitadosRequest = {
        eventoId,
        nombreGrupo: ng,
        tipo,
        maxInvitados,
        adicionalesCantidad: Number(adicionales || 0),
        asistentes: invitados.map((x) => ({
          nombre: x.nombre.trim(),
          apellido: x.apellido.trim(),
          telefono: x.telefono.trim() ? formatPhone(x.codigoPais, x.telefono) : undefined,
          email: x.email.trim() ? x.email.trim() : undefined,
          esPrincipal: x.esPrincipal,
        })),
      };

      const created = await guestGroupService.crearGrupoInvitados(payload);
      onCreated(created);
      cerrar();
    } catch (e) {
      setError(e instanceof Error ? e.message : "Error creando el grupo de invitados");
      setIsSaving(false);
    }
  }

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <button
        className="absolute inset-0 bg-black/60 backdrop-blur-[2px]"
        onClick={cerrar}
        aria-label="Cerrar"
        type="button"
      />

      <div className="relative w-full max-w-3xl max-h-[90vh] rounded-2xl border border-white/10 bg-surface-darker shadow-2xl overflow-hidden flex flex-col">
        <div className="p-6 border-b border-white/10 flex items-start justify-between">
          <div>
            <h3 className="text-xl md:text-2xl font-serif font-semibold text-white">
              Agregar grupo de invitados
            </h3>
            <p className="text-sm text-slate-400 mt-1">
              Organiza tu lista por familias, amigos o invitados especiales.
            </p>
          </div>

          <button
            type="button"
            onClick={cerrar}
            className="text-slate-300 hover:text-white transition-colors disabled:opacity-50"
            aria-label="Cerrar"
            disabled={isSaving}
          >
            <span className="material-symbols-outlined">close</span>
          </button>
        </div>

        <div className="p-6 space-y-6 overflow-y-auto min-h-0">
          {error && (
            <div className="text-sm text-red-300 bg-red-500/10 border border-red-500/20 rounded-lg p-3">
              {error}
            </div>
          )}

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="md:col-span-2">
              <label className="text-xs uppercase tracking-wider text-slate-400 font-semibold">
                Nombre de grupo
              </label>
              <input
                className="mt-2 w-full bg-background-dark text-white px-4 py-3 rounded-lg border border-white/10 focus:outline-none focus:ring-1 focus:ring-primary"
                placeholder="Ej. Familia Pérez"
                value={nombreGrupo}
                onChange={(e) => setNombreGrupo(e.target.value)}
                disabled={isSaving}
              />
            </div>

            <div>
              <label className="text-xs uppercase tracking-wider text-slate-400 font-semibold">
                Tipo
              </label>
              <select
                className="mt-2 w-full bg-background-dark text-white px-4 py-3 rounded-lg border border-white/10 focus:outline-none focus:ring-1 focus:ring-primary"
                value={tipo}
                onChange={(e) => setTipo(e.target.value as guestGroupService.TipoGrupoInvitados)}
                disabled={isSaving}
              >
                <option value="FAMILIA">Familia</option>
                <option value="AMIGOS">Amigos</option>
                <option value="INVITADOS_ESPECIALES">Invitados especiales</option>
              </select>
            </div>

            <div>
              <label className="text-xs uppercase tracking-wider text-slate-400 font-semibold">
                Adicionales
              </label>
              <input
                className="mt-2 w-full bg-background-dark text-white px-4 py-3 rounded-lg border border-white/10 focus:outline-none focus:ring-1 focus:ring-primary"
                type="number"
                min={0}
                value={adicionales}
                onChange={(e) => setAdicionales(Number(e.target.value))}
                disabled={isSaving}
              />
              <p className="text-xs text-slate-500 mt-2">
                Cupo total: <span className="text-white font-semibold">{cupoTotal}</span>
              </p>
            </div>
          </div>

          <div className="rounded-2xl border border-white/10 bg-background-dark/40 p-5">
            <div className="flex items-center justify-between gap-4 mb-4">
              <div>
                <p className="text-xs uppercase tracking-wider text-gold-accent font-semibold">
                  Agregar invitado
                </p>
                <p className="text-xs text-slate-500">
                  Registra el principal y los adicionales del grupo.
                </p>
              </div>

              <button
                type="button"
                onClick={agregarInvitado}
                disabled={isSaving}
                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-gold-accent/90 hover:bg-gold-accent text-black font-semibold transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
              >
                <span className="material-symbols-outlined text-[18px]">add</span>
                Agregar
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                className="w-full bg-background-dark text-white px-4 py-3 rounded-lg border border-white/10 focus:outline-none focus:ring-1 focus:ring-primary"
                placeholder="Nombre"
                value={nuevo.nombre}
                onChange={(e) => setNuevo((p) => ({ ...p, nombre: e.target.value }))}
                disabled={isSaving}
              />
              <input
                className="w-full bg-background-dark text-white px-4 py-3 rounded-lg border border-white/10 focus:outline-none focus:ring-1 focus:ring-primary"
                placeholder="Apellido"
                value={nuevo.apellido}
                onChange={(e) => setNuevo((p) => ({ ...p, apellido: e.target.value }))}
                disabled={isSaving}
              />
              <div className="grid grid-cols-[minmax(0,0.95fr)_minmax(0,1.45fr)] gap-3">
                <div className="relative">
                  <input
                    className="w-full bg-background-dark text-white px-4 py-3 rounded-lg border border-white/10 focus:outline-none focus:ring-1 focus:ring-primary"
                    placeholder="Pais o codigo"
                    value={codigoPaisQuery}
                    onChange={(e) => {
                      setCodigoPaisQuery(e.target.value);
                      setIsCountryCodeOpen(true);
                    }}
                    onFocus={() => setIsCountryCodeOpen(true)}
                    onBlur={() => {
                      window.setTimeout(() => {
                        setIsCountryCodeOpen(false);
                        setCodigoPaisQuery(`${selectedCountryCode.country} ${selectedCountryCode.code}`);
                      }, 120);
                    }}
                    disabled={isSaving}
                    aria-label="Codigo de pais"
                  />
                  {isCountryCodeOpen && (
                    <div className="absolute z-20 mt-2 max-h-56 w-full overflow-y-auto rounded-lg border border-white/10 bg-surface-darker shadow-xl">
                      {filteredCountryCodes.length === 0 && (
                        <div className="px-3 py-2 text-sm text-slate-400">
                          Sin resultados
                        </div>
                      )}

                      {filteredCountryCodes.map((option) => (
                        <button
                          type="button"
                          key={`${option.country}-${option.code}`}
                          className="flex w-full items-center justify-between gap-3 px-3 py-2 text-left text-sm text-slate-200 hover:bg-white/10"
                          onMouseDown={(e) => e.preventDefault()}
                          onClick={() => {
                            setNuevo((p) => ({ ...p, codigoPais: option.code }));
                            setCodigoPaisQuery(`${option.country} ${option.code}`);
                            setIsCountryCodeOpen(false);
                          }}
                        >
                          <span className="truncate">{option.country}</span>
                          <span className="font-semibold text-gold-accent">{option.code}</span>
                        </button>
                      ))}
                    </div>
                  )}
                </div>

                <input
                  className="w-full bg-background-dark text-white px-4 py-3 rounded-lg border border-white/10 focus:outline-none focus:ring-1 focus:ring-primary"
                  placeholder="Numero"
                  value={nuevo.telefono}
                  onChange={(e) => setNuevo((p) => ({ ...p, telefono: e.target.value }))}
                  disabled={isSaving}
                  aria-label="Numero de telefono"
                />
              </div>
              <input
                className="w-full bg-background-dark text-white px-4 py-3 rounded-lg border border-white/10 focus:outline-none focus:ring-1 focus:ring-primary"
                placeholder="Correo (opcional)"
                value={nuevo.email}
                onChange={(e) => setNuevo((p) => ({ ...p, email: e.target.value }))}
                disabled={isSaving}
              />
            </div>

            <label className="mt-4 inline-flex items-center gap-2 text-sm text-slate-300 select-none">
              <input
                type="checkbox"
                checked={nuevo.esPrincipal}
                onChange={(e) => setNuevo((p) => ({ ...p, esPrincipal: e.target.checked }))}
                className="rounded border-white/20 bg-background-dark text-primary focus:ring-primary"
                disabled={isSaving}
              />
              Invitado principal
            </label>
          </div>

          <div>
            <p className="text-sm font-semibold text-white">
              Invitados en este grupo ({invitados.length})
            </p>

            <div className="mt-3 space-y-2">
              {invitados.length === 0 && (
                <div className="text-sm text-slate-500 italic">
                  Aún no agregas invitados.
                </div>
              )}

              {invitados.map((x, idx) => (
                <div
                  key={`${x.nombre}-${x.apellido}-${idx}`}
                  className="flex items-center justify-between gap-3 rounded-xl border border-white/10 bg-surface-dark/60 p-4"
                >
                  <div className="flex items-center gap-3 min-w-0">
                    <div className="size-10 rounded-full bg-primary/15 border border-primary/25 flex items-center justify-center shrink-0">
                      <span className="material-symbols-outlined text-primary">person</span>
                    </div>

                    <div className="min-w-0">
                      <div className="flex items-center gap-2 flex-wrap">
                        <p className="text-white font-semibold truncate">
                          {x.nombre} {x.apellido}
                        </p>
                        {x.esPrincipal && (
                          <span className="text-[11px] px-2 py-0.5 rounded-full bg-gold-accent/20 text-gold-accent border border-gold-accent/20 font-bold">
                            PRINCIPAL
                          </span>
                        )}
                      </div>
                      <p className="text-xs text-slate-400 truncate">
                        {x.email || "Sin correo"}{" "}
                        <span className="text-slate-600">•</span>{" "}
                        {formatPhone(x.codigoPais, x.telefono) || "Sin teléfono"}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center gap-2 shrink-0">
                    <button
                      type="button"
                      onClick={() => marcarPrincipal(idx)}
                      disabled={isSaving}
                      className="px-3 py-2 rounded-lg text-xs font-semibold bg-white/5 hover:bg-white/10 border border-white/10 text-white transition-colors disabled:opacity-60"
                      title="Marcar como principal"
                    >
                      Principal
                    </button>

                    <button
                      type="button"
                      onClick={() => eliminarInvitado(idx)}
                      disabled={isSaving}
                      className="p-2 rounded-lg text-slate-300 hover:text-red-400 hover:bg-white/5 transition-colors disabled:opacity-60"
                      title="Eliminar"
                    >
                      <span className="material-symbols-outlined">delete</span>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="p-6 border-t border-white/10 flex items-center justify-end gap-3">
          <button
            type="button"
            onClick={cerrar}
            disabled={isSaving}
            className="px-4 py-2.5 rounded-lg text-sm font-semibold text-slate-200 bg-white/5 hover:bg-white/10 border border-white/10 transition-colors disabled:opacity-60"
          >
            Cancelar
          </button>

          <button
            type="button"
            onClick={guardar}
            disabled={isSaving}
            className="px-5 py-2.5 rounded-lg text-sm font-semibold text-black bg-gold-accent/90 hover:bg-gold-accent transition-colors disabled:opacity-60"
          >
            {isSaving ? "Guardando..." : "Guardar grupo de invitados"}
          </button>
        </div>
      </div>
    </div>
  );
}
